import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/App/Layout'
import Navbar from '../components/App/Navbar'
import PageBanner from '../components/Common/PageBanner'
import Footer from '../components/App/Footer'
import BlogCard from '../components/BlogContent/BlogCard'
import SEO from '../components/App/SEO'

const Blog = ({ data, pageContext }) => {
  const posts = data.allContentfulBlogPost.edges
  const { currentPage, numPages } = pageContext

  return (
    <Layout>
      <SEO title="Blog" />
      <Navbar />
      <PageBanner
        pageTitle="Blog"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Blog"
      />
      <BlogCard posts={posts} currentPage={currentPage} numPages={numPages} />
      <Footer />
    </Layout>
  )
}

export default Blog

export const query = graphql`
  query blogMainQuery($skip: Int!, $limit: Int!) {
    allContentfulBlogPost(
      limit: $limit
      skip: $skip
      sort: { order: DESC, fields: createdAt }
    ) {
      edges {
        node {
          slug
          title
          createdAt(formatString: "DD MMMM YYYY")
          featured {
            fluid(maxWidth: 750) {
              srcWebp
            }
          }
        }
      }
    }
  }
`
